import { IconButton, Select } from '@nike/eds'

import styles from '../Table.module.styl'

type PaginationControlsProps = {
  table: {
    setPageIndex: (index: number) => void
    previousPage: () => void
    nextPage: () => void
    getCanPreviousPage: () => boolean
    getCanNextPage: () => boolean
    getPageCount: () => number
    setPageSize: (size: number) => void
    getFilteredRowModel: () => { rows: any[] }
    getRowCount: () => number
    getState: () => {
      pagination: {
        pageIndex: number
        pageSize: number
      }
    }
  }
  pageSizeOptions: number[]
}

export function PaginationControls({ table, pageSizeOptions }: PaginationControlsProps) {
  const currentPage = table.getState().pagination.pageIndex
  const pageSize = table.getState().pagination.pageSize
  const totalItems = table.getRowCount()

  const startIndex = currentPage * pageSize + 1
  const endIndex = Math.min((currentPage + 1) * pageSize, totalItems)

  const formattedPageSizeOptions = pageSizeOptions.map((size) => ({
    value: size,
    label: size,
  }))

  return (
    <div className={styles.paginationToolbar}>
      <IconButton
        className={styles.paginationControls}
        icon='CaretLeft'
        variant='ghost'
        label='Previous page'
        onClick={() => table.previousPage()}
        disabled={!table.getCanPreviousPage()}
        disableRipple
      />
      <IconButton
        className={styles.paginationControls}
        icon='CaretRight'
        label='Next page'
        variant='ghost'
        onClick={() => table.nextPage()}
        disabled={!table.getCanNextPage()}
        disableRipple
      />

      <div>Results:</div>

      <Select
        id='page-size-select'
        options={formattedPageSizeOptions}
        value={formattedPageSizeOptions.find((option) => option.value === pageSize)}
        onChange={(selected: any) => table.setPageSize(Number(selected.value))}
        hideLabel
        label=''
        menuPosition='fixed'
      />

      <span>
        {startIndex}-{endIndex} of {totalItems}
      </span>
    </div>
  )
}
